import PhotoSwipeLightbox from 'photoswipe/lightbox';

import ApplicationController from '../application-controller';

export default class extends ApplicationController {
  declare lightbox?: PhotoSwipeLightbox;

  static targets = ['gallery'];

  declare readonly hasGalleryTarget: boolean;
  declare readonly galleryTarget: HTMLElement;
  declare readonly galleryTargets: HTMLElement[];

  static values = {
    childrenSelector: { type: String, default: 'a' },
  };

  declare readonly childrenSelectorValue: string;

  connect() {
    super.connect();
    this.initLightbox();
  }

  disconnect() {
    super.disconnect();

    if (this.lightbox) {
      this.lightbox.destroy();
    }
  }

  get galleryContainer() {
    if (this.hasGalleryTarget) {
      return this.galleryTarget;
    }

    return this.element as HTMLElement;
  }

  initLightbox() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.galleryContainer,
      children: this.childrenSelectorValue,
      pswpModule: () => import('photoswipe'),

      closeTitle: 'Fermer',
      zoomTitle: 'Zoom',
      arrowPrevTitle: 'Précédent',
      arrowNextTitle: 'Suivant',
      errorMsg: 'Erreur de chargement de l\'image',
    });

    this.lightbox.init();
  }
}
